<template>
    <div id="reservation_list">


        <el-radio-group v-model="tabAction" style="margin-bottom: 15px;">
            <el-radio-button v-for="item in $const.TRAVELORDERSTATUS" :key="item.value" :label="item.value">{{
                item.label }}</el-radio-button>
            <el-radio-button label="">全部</el-radio-button>
        </el-radio-group>

        <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns" :excel-type="btnPreFn('travel_order_export', false) ? 'TravelOrder' : ''"
            style="height: 95%">
            <template slot="table-operation">
                <el-table-column label="操作" width="80" fixed="right">
                    <div slot-scope="{ row }" class="custom-action">
                        <el-button type="text" v-if="row.status == 8" @click="assignShow(row, 'assign')">派车</el-button>
                        <el-button type="text" v-if="row.status == 10"
                            @click="assignShow(row, 'reassign')">改派</el-button>
                    </div>
                </el-table-column>
            </template>

            <template slot-scope="{ item, row }">
                <template v-if="['created', 'finishTime', 'orderTime'].includes(item.prop)">
                    {{ row[item.prop] | filterTime }}
                </template>
                <template v-else-if="item.prop === 'orderNo'">
                    <span class="link" @click="viewOrder(row)">{{ row.orderNo }}</span>
                    <el-tag class="ml-5" v-for="item in $const.TRAVELALLORDERSTATUS.filter(item => item.value === row.status)"
                        :key="item.value" :type="item.type">{{ item.label }}</el-tag>
                </template>
                <template v-else-if="item.prop === 'passengerNum'">
                    {{ row.passengerNum }}人 ({{ row.poolType == 2 ? '拼车' : '包车' }})
                </template>
                <template v-else-if="item.prop === 'contactPhone'">
                    <div>{{ row.contactPerson }}</div>
                    <div @dbclick="$utils.copyText(row.contactPhone)">{{ row.contactPhone }}</div>
                </template>


                <template v-else-if="item.prop === 'licenseNo'">
                    <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
                    <span v-else>-</span>
                </template>
                <template v-else>
                    <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ?
                        row[item.prop] : "-" }}</span>
                </template>
            </template>
        </custom-table>
        <!-- 指派到顺路行程 -->
        <el-drawer title="" :visible.sync="drawerVisible" size="70%" destroy-on-close>
            <div class="drawer-content">
                <h3 style="margin-bottom: 16px;">指派到顺路行程</h3>
                <custom-table ref="wayCustomTable" :refreshShow="false" :customOptions="wayCustomOptions"
                    :columns="wayColumns" maxHeight="409" :loadmoreSwitch="true">
                    <template slot="table-operation">
                        <el-table-column label="操作" width="80" fixed="right">
                            <template slot-scope="{ row }">
                                <el-button type="text" :loading="assignLoading"
                                    @click="assignFn(row, 'way')">指派</el-button>
                            </template>
                        </el-table-column>
                    </template>

                    <template slot-scope=" { item, row }">
                        <template v-if="item.prop === 'status'">
                            <el-tag v-for="item in $const.TRAVELTRIPSTATUS.filter(item => item.value == row.status)"
                                :key="item.value" :type="item.type">{{ item.label }}</el-tag>
                        </template>
                        <template v-else-if="item.prop === 'orderTime'">
                             {{ row.orderTime | filterTime }}
                        </template>
                        <template v-else-if="item.prop === 'licenseNo'">
                            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
                            <span v-else>-</span>
                        </template>

                        <template v-else>{{
                            row[item.prop] ? row[item.prop] : "-"
                        }}</template>
                    </template>
                </custom-table>
                <div class="no-way">没有合适顺路的行程？<span @click="assignDriver">指派给空闲司机</span></div>
            </div>
        </el-drawer>
        <!-- 指派给空闲司机 -->
        <el-drawer title="" :visible.sync="driverVisible" size="70%" destroy-on-close>
            <div class="drawer-content">
                <h3 style="margin-bottom: 16px;">指派给空闲司机</h3>

                <custom-table ref="driverCustomTable" :refreshShow="false" :customOptions="driverCustomOptions"
                    :columns="driverColumns" maxHeight="510" :loadmoreSwitch="true">
                    <template slot="table-operation">
                        <el-table-column label="操作" width="80" fixed="right">
                            <template slot-scope="{ row }">
                                <el-button type="text" :loading="assignLoading"
                                    @click="assignFn(row, 'free')">指派</el-button>
                            </template>
                        </el-table-column>
                    </template>


                    <template slot-scope=" { item, row }">
                        <template v-if="item.prop === 'vehicleSeat'">
                            {{ row.vehicleSeat }}座
                        </template>
                        <template v-else-if="item.prop === 'orderDriverList'">
                            <span style="cursor: pointer; color: #409EFF;" v-if="row.orderDriverList?.length > 0"
                                @click="viewDriverOrder(row)">
                                {{ row.orderDriverList.length }}
                            </span>
                            <span class="tips" v-else>空闲</span>
                        </template>
                        <template v-else-if="item.prop === 'licenseNo'">
                            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
                            <span v-else>-</span>
                        </template>

                        <template v-else>{{
                            row[item.prop] ? row[item.prop] : "-"
                        }}</template>
                    </template>
                </custom-table>
            </div>
        </el-drawer>
        <el-dialog :title="`${driverInfo.licenseNo} ${driverInfo.vehicleSeat}座 ${driverInfo.driverName}`"
            :visible.sync="orderDialogVisible" width="30%" destroy-on-close>
            <el-table :data="driverInfo.orderDriverList">
                <el-table-column prop="travelLineName" label="行程线路"></el-table-column>
                <el-table-column prop="orderTime" label="用车时间" width="120">
                    <template slot-scope="scope">{{ scope.row.orderTime | filterTime }}</template>
                </el-table-column>
            </el-table>
        </el-dialog>


    </div>
</template>

<script>

export default {
    name: "reservation_list",
    data() {
        return {
            tabAction: 8,
            // 配置项
            customOptions: {
                url: "/api/v1/manage/travelOrder/order/list",
                params: {
                    page: 1, // 页数
                    size: 20, // 每页条数
                    status: 8
                },
                search: [
                    { type: "input", field: "orderNo", name: "订单编号", value: "" },
                    { type: "input", field: "contactPhone", name: "联系电话", value: "" },
                    // { type: "select", field: "goodsName", name: "旅游产品", value: "", options: [], remoteOption: { url: '/api/v1/manage/travelGoods', labelKey: 'name', valueKey: 'id' } },
                    { type: "input", field: "goodsName", name: "旅游产品", value: "" },
                    { type: "select", field: "poolType", name: "拼车/包车",option: this.$const.LYPOOLTYPE, value: "" },
                    { type: "datetime", disabledDate: false, field: "orderTime", name: "用车时间", dateProp: { start: "startOrderTime", end: "endOrderTime" }, value: [] },
                    { type: "datetime", disabledDate: false, field: "created", dateProp: { start: "startTime", end: "endTime" }, name: "下单时间", value: [] },
                    { type: "datetime", disabledDate: false, field: "finishTime", dateProp: { start: "startFinishTime", end: "endFinishTime" }, name: "完成/取消时间", value: [] },
                ],
            },
            // 表头
            columns: [
                { prop: "orderNo", label: "订单编号", width: 200 },
                { prop: "travelLineName", label: "线路名称", width: 100 },
                { prop: "orderTime", label: "用车时间", width: 120 },
                { prop: "contactPhone", label: "联系信息", width: 100 },
                { prop: "passengerNum", label: "乘客数", width: 80 },
                { prop: "goodsName", label: "文旅商品", minWidth: 120 },
                { prop: "created", label: "下单时间", width: 120 },
                { prop: "finishTime", label: "完成/取消时间", width: 120 },
            ],
            rowData: {},
            drawerVisible: false,
            wayCustomOptions: {
                url: "/api/v1/manage/travelOrder/order/driver/vehicle",

                params: {
                    page: 1, // 页数
                    size: 20, // 每页条数
                },
                search: [
                    { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
                    { type: "input", field: "driverName", name: "值班司机", value: "" },
                    { type: "select", field: "status", name: "行程状态", value: "", option: this.$const.TRAVELTRIPSTATUS },
                ],
            },
            wayColumns: [
                { prop: "organizationName", label: "机构名称", minWidth: 120 },
                { prop: "orderDriverNo", label: "行程编号", width: 180 },
                { prop: "orderTime", label: "用车时间", width: 120 },
                { prop: "status", label: "状态", minWidth: 80 },
                { prop: "licenseNo", label: "车辆号牌", minWidth: 100 },
                { prop: "remainingSeat", label: "剩余座位", minWidth: 100 },
                { prop: "vehicleModel", label: "车辆型号", minWidth: 100 },
                { prop: "driverName", label: "值班司机", minWidth: 100 },
                { prop: "driverPhone", label: "联系电话", minWidth: 100 },
            ],

            driverVisible: false,
            driverCustomOptions: {
                url: "/api/v1/manage/travelOrder/assign/vehicle",
                params: {
                    page: 1, // 页数
                    size: 20, // 每页条数
                },
                search: [
                    { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
                    { type: "input", field: "driverName", name: "值班司机", value: "" },
                ],
            },
            driverColumns: [
                { prop: "organizationName", label: "机构名称", minWidth: 120 },
                { prop: "licenseNo", label: "车辆号牌", minWidth: 100 },
                { prop: "vehicleSeat", label: "车辆座位", minWidth: 100 },
                { prop: "vehicleModel", label: "车辆型号", minWidth: 100 },
                { prop: "driverName", label: "值班司机", minWidth: 100 },
                { prop: "orderDriverList", label: "已有行程", minWidth: 100 },
                { prop: "driverPhone", label: "联系电话", minWidth: 100 },
            ],
            orderDialogVisible: false,
            driverInfo: {},
            assignLoading: false,
            assignType: 'assign'
        };


    },
    watch: {
        tabAction(val) {
            this.customOptions.params.page = 1;
            this.customOptions.params.status = val != "all" ? val : null;
            this.$refs.customTable.listFn();
        },
    },
    created() {

    },
    methods: {
        // 司机已有行程
        viewDriverOrder(row) {
            this.driverInfo = { ...row };
            this.orderDialogVisible = true;
        },
        // 打开指派抽屉
        assignShow(row, type) {
            this.assignType = type;
            this.wayCustomOptions.params.id = row.id;
            this.rowData = { ...row };
            this.drawerVisible = true;
        },
        // 打开空闲司机抽屉
        assignDriver() {
            this.driverCustomOptions.params.id = this.rowData.id;
            this.drawerVisible = false;
            this.driverVisible = true;
        },
        // 确认指派
        async assignFn(row, type) {
            let tipsTitle = this.rowData.poolType == 1 
                ? '包车订单' 
                : (type == 'way' ? '指派行程' : '指派司机');
            let tipsContent = this.rowData.poolType == 1 
                ? '当前乘客需要包车，是否要继续指派到该拼车行程？' 
                : (type == 'way' ? '是否确认将当前订单指派到该行程？' : '是否确认将当前订单指派到该司机？');
            this.$confirm(tipsContent, tipsTitle, {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
            }).then(async () => {
                let url = "";
                if (this.assignType == 'assign') {
                    url = '/api/v1/manage/travelOrder/assign/vehicle'
                } else {
                    url = '/api/v1/manage/travelOrder/assign/again/vehicle'
                }
                let params = {
                    orderId: this.rowData.id,
                    vehicleId: row.vehicleId,
                    driverId: row.driverId
                }
                if (type == 'way') {
                    params.orderDriverId = row.id //工单id--指派给顺路车辆时传值
                }
                this.assignLoading = true;
                let { code } = await this.$axios.post(url, params);
                if (code == 1) {
                    this.$message.success('订单指派成功')
                    this.driverVisible = false;
                    this.drawerVisible = false;
                    this.$refs.customTable.listFn()
                }
                this.assignLoading = false;
            });

        },
        // 订单详情
        viewOrder(row) {
            this.$router.push({
                path: '/travelOrderDetail',
                query: {
                    id: row.id
                }
            })
        },

    },
};
</script>

<style lang="less">
.no-way {
    margin-top: 14px;
    color: #999;

    span {
        color: #409EFF;
        cursor: pointer;
    }
}
</style>
